<p>
    Soul Grinder is a horde survival action rogue-like. Survive an onslaught of
    enemies with necromancy and dark magic at your disposal! Try to survive as
    long as you can and collect gems to upgrade your power.
</p>

<p>
    I built Soul Grinder over the course of two weeks as personal challenge and
    break from my main project. I wanted to try building a game like vampire
    survivors with a twist of necromancy. Ultimately the game felt less original
    than I wanted. There's a lot more features I would like to have added but I
    decided to move forward with different projects. Still, I'm happy with how
    the game turned out and how much I was able to accomplish in such a short
    time span.
</p>
